var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otp-input d-block text-center justify-content-center"},_vm._l((_vm.textArr),function(item,index){return _c('input',{key:index,ref:'input_text_' + index,refInFor:true,staticClass:"otp",attrs:{"autocomplete":"false","type":"text","maxlength":"1"},on:{"keyup":function($event){return _vm.changeValue($event, index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }